import React, { useState } from "react";
import "./portfolio.css";
import Menu from "./Menu";

const Portfolio = () => {
  const [items, setItems] = useState(Menu);
  const filterItem = (catergoryItem) => {
    const updatedItems = Menu.filter((curElem) => {
      return curElem.category === catergoryItem;
    });

    setItems(updatedItems);
  };
  return (
    <section className="work container section" id="work">
      <h2 className="section__title">Proyectos Recientes</h2>

      <div className="work__filters">
        <span className="work__item" onClick={() => setItems(Menu)}>Todo</span>
        <span className="work__item" onClick={() => filterItem("Web")}>
          Web
        </span>
        <span className="work__item" onClick={() => filterItem("Social Media")}>
          Social Media
        </span>
        <span className="work__item" onClick={() => filterItem("Diseño")}>
          Diseño
        </span>
        <span className="work__item" onClick={() => filterItem("Branding")}>
          Branding
        </span>
      </div>

      <div className="work__container grid">
        {items.map((elem) => {
          const { id, image, title, category, link } = elem;
          return (
            <div className="work__card" key={id}>
              <div className="work__thumbnail">
                <img src={image} alt="" className="work___img" />
                <div className="work__mask"></div>
              </div>

              <span className="work__category">{category}</span>
              <h3 className="work__title">{title}</h3>
              <a href={link} className="work__button" target="_blank" rel="noreferrer">
                <i className="icon-link work__button-icon"></i>
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
